import styled from 'styled-components';
import Colors from '@/constants/Colors';

export const StyledTaskStudentsEditor = styled.div`
  flex: 1;
  height: 100%;

  .students-container {
    height: 100%;
    padding: 20px;
    border-radius: 8px;
    background-color: ${Colors.backgroundPaleBlue};

    .students {
      .student {
        border-bottom: 1px solid white;
        padding: 10px 0px;
      }
    }
  }

  .ant-spin-nested-loading,
  .ant-spin-container {
    height: 100%;
  }
`;
